'use strict'

export const ADD_STAKE_NUMBER = 'ADD_STAKE_NUMBER'
export const REMOVE_STAKE_NUMBER = 'REMOVE_STAKE_NUMBER'
export const RECEIVE_STAKES_SET = 'RECEIVE_STAKES_SET'
export const EMPTY_STAKES = 'EMPTY_STAKES'



// WEBPACK FOOTER //
// ./resources/assets/js/lotto/store/mutation-types.js